import React from 'react';
import { SummaryCard, SummaryGrid, SummaryItem, SummaryLabel, SummaryValue, SummaryValueGreen } from './styles';
import { PopularItemsSummaryProps } from './types';

const PopularItemsSummary: React.FC<PopularItemsSummaryProps> = ({ summary, borderColor = '#4299E1' }) => {
  return (
    <SummaryCard borderColor={borderColor}>
      <SummaryGrid>
        <SummaryItem>
          <SummaryLabel>Total Revenue</SummaryLabel>
          <SummaryValue>${summary?.totalRevenue?.toLocaleString() || 0}</SummaryValue>
        </SummaryItem>
        <SummaryItem>
          <SummaryLabel>Items Sold</SummaryLabel>
          <SummaryValueGreen>{summary?.totalItemsSold?.toLocaleString() || 0}</SummaryValueGreen>
        </SummaryItem>
        <SummaryItem>
          <SummaryLabel>Average Item Price</SummaryLabel>
          <SummaryValue>${summary?.averageItemPrice?.toFixed(2) || 0}</SummaryValue>
        </SummaryItem>
        <SummaryItem>
          <SummaryLabel>Total Items</SummaryLabel>
          <SummaryValue>{summary?.totalItems || 0}</SummaryValue>
        </SummaryItem>
      </SummaryGrid>
    </SummaryCard>
  );
};

export default PopularItemsSummary;
